import { render, staticRenderFns } from "./edit-advertiser.vue?vue&type=template&id=0721f098&scoped=true"
import script from "./edit-advertiser.vue?vue&type=script&lang=js"
export * from "./edit-advertiser.vue?vue&type=script&lang=js"
import style0 from "./edit-advertiser.vue?vue&type=style&index=0&id=0721f098&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0721f098",
  null
  
)

export default component.exports